import React, { useState } from 'react'
import { prop } from 'ramda'
import PropTypes from 'prop-types'
import { lifecycle } from 'recompose'
import ContentBoxWithoutHeader from '../../../layout/component/ContentBoxWithoutHeader'
import ContentBoxHeader from '../../../layout/component/ContentBoxHeader'
import Row from '../../../bootstrap/component/Row'
import Column from '../../../bootstrap/component/Column'
import ContentBoxBody from '../../../layout/component/ContentBoxBody'
import { BACKEND_URL } from '../../../../util/api'
import {
    DEFINED_IMAGE_LIST,
    IMAGE_TYPE_SELECT,
    MAX_IMAGE_SIZE,
} from '../../state/detail/const'
import ImageGallery from 'react-image-gallery'
import Dropzone from 'react-dropzone'
import 'react-image-gallery/styles/css/image-gallery.css'
import { formatDateTime } from '../../../../util/datetime'
import ToggleButton from '../../../form/component/ToggleButton'
import Select from '../../../form/component/Select'
import currentUserHasAccess from '../../../../util/widget-helper'
import { CUSTOMER_IMAGE_WIDGET } from '../../../process/ui-definition/process-ui'
import DeleteModal from './DeleteModal'

const DOWNLOAD_URL = BACKEND_URL + '/api/customer/download-images?customerId='

const moment = require('moment')

const deleteStyle = {
    float: 'right',
}

const style = {
    width: '100%',
    height: '200px',
    borderWidth: '2px',
    borderColor: 'rgb(102, 102, 102)',
    borderStyle: 'dashed',
    borderRadius: '5px',
    padding: '35px',
    textAlign: 'center',
    cursor: 'pointer',
    marginTop: '60px',
}

const ROTATE_CSS = {
    0: 'rotate-0',
    90: 'rotate-90',
    180: 'rotate-180',
    270: 'rotate-270',
}

const RenderDeleteImage = ({ fileId, imageType, versionId, deleteCustomerImage }) => {
    const [showConfirmationModal, setShowConfirmationModal] = useState(false)

    const handleOnClick = () => {
        setShowConfirmationModal(true)
    }

    return (
        <div>
            <button type={'button'} className={'btn btn-danger'} style={deleteStyle} onClick={handleOnClick}>
                <span className={'glyphicon glyphicon-trash'}> Delete </span>
            </button>
            {showConfirmationModal && <DeleteModal
                processDelete={() => deleteCustomerImage(fileId, imageType, versionId)}
                isOpen={showConfirmationModal}
                handleClose={ () => setShowConfirmationModal(false)}
            />}
        </div>
    )
}

const renderImage = ({
    rotateCustomerImage,
    customerId,
    setImageTypeMetaData,
    lastModified,
    fileId,
    versionId,
    originalImageType,
    original,
    rotate,
    image,
    path,
    deleteCustomerImage,
    showDeleteImage,
}) => {
    return (
        <div>
            <div className="image-slider-header">
                <div className="inline-block vertical-align-top">
                    <span className="badge">{lastModified}</span>
                </div>
                <div className="inline-block vertical-align-top image-slide-select">
                    <Select
                        object={{}}
                        name="name"
                        addEmpty={true}
                        style={{ height: '18px' }}
                        valueList={IMAGE_TYPE_SELECT}
                        onChange={(name, newImageType) => {
                            if (!newImageType || newImageType === image.name) {
                                return
                            }
                            setImageTypeMetaData(
                                customerId,
                                originalImageType,
                                versionId,
                                path,
                                newImageType,
                            )
                        }}
                    />
                </div>
                <div className="inline-block vertical-align-top">
                    <i
                        className="customer-image-rotate-icon fa fa-rotate-left"
                        onClick={event => {
                            event.stopPropagation()
                            event.preventDefault()
                            rotateCustomerImage(
                                originalImageType,
                                versionId,
                                -90,
                            )
                        }}
                    />
                    &#160;
                    <i
                        className="customer-image-rotate-icon fa fa-rotate-right"
                        onClick={event => {
                            event.stopPropagation()
                            event.preventDefault()
                            rotateCustomerImage(
                                originalImageType,
                                versionId,
                                90,
                            )
                        }}
                    />
                </div>
            </div>
            <div style={{ overflow: 'hidden' }}>
                <img className={ROTATE_CSS[rotate]} src={original} alt="" />
            </div>
            {showDeleteImage && fileId && <RenderDeleteImage fileId={fileId} deleteCustomerImage={deleteCustomerImage} imageType={originalImageType} versionId={versionId}/>}
        </div>
    )
}
const renderThumbnail = ({ original, rotate }) => {
    return (
        <div
            style={{
                overflow: 'hidden',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
            }}
        >
            <img className={ROTATE_CSS[rotate]} src={original} alt="" />
        </div>
    )
}

const VersionedImageGallery = ({
    versionImageList,
    rotateCustomerImage,
    image,
    setImageTypeMetaData,
    customerId,
    deleteCustomerImage,
    showDeleteImage,
}) => {
    if (!versionImageList) {
        return null
    }

    versionImageList.sort((a, b) => {
        a = a.lastModified
        b = b.lastModified
        if (!a && !b) {
            return 0
        }
        if (!a && b) {
            return -1
        }
        if (a && !b) {
            return 1
        }
        return moment(a).unix() - moment(b).unix()
    })

    const imageList = versionImageList.map(version => {
        return {
            path: version.path,
            original: BACKEND_URL + version.link,
            thumbnail: BACKEND_URL + version.link,
            lastModified: formatDateTime(version.lastModified),
            fileName: image.name,
            fileId: version.fileId,
            versionId: version.versionId,
            rotate:
                version.meta && version.meta.rotate ? version.meta.rotate : 0,
            originalImageType: version.originalImageType,
            image,
            rotateCustomerImage,
            setImageTypeMetaData,
            customerId,
            deleteCustomerImage,
            showDeleteImage,
        }
    })

    return (
        <ImageGallery
            startIndex={imageList.length - 1}
            renderItem={renderImage}
            infinite={false}
            items={imageList}
            renderThumbInner={renderThumbnail}
            showFullscreenButton={false}
        />
    )
}

const VersionedImage = ({
    image,
    versionImageList,
    customerId,
    uploadCustomerImage,
    rotateCustomerImage,
    setImageTypeMetaData,
    deleteCustomerImage,
    showDeleteImage,
}) => {
    return (
        <Row top="M">
            <Column size={8}>
                <h2>{image.title}</h2>
                <VersionedImageGallery
                    image={image}
                    customerId={customerId}
                    rotateCustomerImage={rotateCustomerImage}
                    setImageTypeMetaData={setImageTypeMetaData}
                    versionImageList={versionImageList}
                    deleteCustomerImage={deleteCustomerImage}
                    showDeleteImage={showDeleteImage}
                />
            </Column>
            <Column size={4}>
                <Dropzone
                    multiple={false}
                    accept="image/*"
                    maxSize={MAX_IMAGE_SIZE}
                    style={style}
                    disablePreview={true}
                    onDrop={fileList => {
                        uploadCustomerImage(fileList, image.name, customerId)
                    }}
                >
                    <p>Click to upload a picture</p>
                </Dropzone>
            </Column>
        </Row>
    )
}

const ImageDownload = ({ imageVersionList, customerId }) => {
    if (!imageVersionList || Object.keys(imageVersionList).length === 0) {
        return null
    }
    return (
        <Row>
            <Column>
                <a href={DOWNLOAD_URL + customerId}>download</a>
            </Column>
        </Row>
    )
}

const VersionedImageList = ({
    canSeeImages,
    setImageTypeMetaData,
    imageVersionList,
    uploadCustomerImage,
    deleteCustomerImage,
    rotateCustomerImage,
    customerId,
    showImages,
    showDeleteImage,
    toggleImageView,
    skipImages = [],
}) => {
    if (!currentUserHasAccess(CUSTOMER_IMAGE_WIDGET)) {
        return null
    }

    if (!canSeeImages) {
        return null
    }

    return (
        <ContentBoxWithoutHeader>
            <ContentBoxHeader>
                <Row>
                    <Column size={8}>
                        <h1>Patient Photos</h1>
                    </Column>
                    <Column size={4} className="align-right">
                        <ToggleButton
                            toggle={toggleImageView}
                            active={showImages}
                            activeIcon="fa fa-search-minus"
                            inactiveIcon="fa fa-search-plus"
                        />
                    </Column>
                </Row>
            </ContentBoxHeader>
            <ContentBoxBody>
                <ImageDownload
                    imageVersionList={imageVersionList}
                    customerId={customerId}
                />
                {showImages &&
                    DEFINED_IMAGE_LIST.map((image, index) => {
                        if (skipImages.includes(image.name)) {
                            return null
                        }
                        return (
                            <VersionedImage
                                key={index}
                                image={image}
                                customerId={customerId}
                                setImageTypeMetaData={setImageTypeMetaData}
                                rotateCustomerImage={rotateCustomerImage}
                                uploadCustomerImage={uploadCustomerImage}
                                deleteCustomerImage={deleteCustomerImage}
                                versionImageList={imageVersionList[image.name]}
                                showDeleteImage={showDeleteImage}
                            />
                        )
                    })}
            </ContentBoxBody>
        </ContentBoxWithoutHeader>
    )
}

VersionedImageList.propTypes = {
    customerId: PropTypes.string,
    findImageVersion: PropTypes.func.isRequired,
    uploadCustomerImage: PropTypes.func.isRequired,
    deleteCustomerImage: PropTypes.func,
    rotateCustomerImage: PropTypes.func.isRequired,
    showImages: PropTypes.bool.isRequired,
    toggleImageView: PropTypes.func.isRequired,
    canSeeImages: PropTypes.bool.isRequired,
    skipImages: PropTypes.arrayOf(
        PropTypes.oneOf(DEFINED_IMAGE_LIST.map(prop('name'))),
    ),
    imageVersionList: PropTypes.object,
    setImageTypeMetaData: PropTypes.func,
    showDeleteImage: PropTypes.object,
}

export default lifecycle({
    componentDidMount () {
        this.props.findImageVersion(this.props.customerId)
    },
})(VersionedImageList)



// WEBPACK FOOTER //
// ./src/modules/customer/component/image/VersionedImageList.js